exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "textarea {\n  min-height: 250px; }\n\ninput {\n  min-width: 100px; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/lib/loader.js!./src/nbinput/nbinput-text.component.scss
// module id = 163
// module chunks = 0 1